module.exports = __webpack_public_path__ + "img/ic_btn_ing_w.95858e38.svg";